<span>
  {{ displayValue }}

  <span class="round-counter" [ngClass]="{ 'round-counter-empty': empty }">
    {{ data?.row_detalhe_pacote?.length ?? 0 }}
    /
    {{ data?.row_criticas_item?.length ?? 0 }}
    /
    {{ data?.row_motivos_rejeicao?.length ?? 0 }}
  </span>
</span>
